import page404 from "./404";
import page500 from "./500";
import passwordVault from "./password_vault";
import utils from "./utils";

const shared = {
	page_404: page404,
	page_500: page500,
	password_vault: passwordVault,
	utils: utils,
};

export default shared;
